import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api } from '../../utils/api';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { LogIn, UserPlus } from 'lucide-react';

export default function CustomerLogin() {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let res;
      if (mode === 'login') {
        res = await api.customerLogin({ email, password });
      } else {
        res = await api.customerRegister({ email, password, name });
      }
      localStorage.setItem('customer_token', res.data.token);
      localStorage.setItem('customer_info', JSON.stringify(res.data.customer));
      toast.success(mode === 'login' ? 'Inloggad!' : 'Konto skapat!');
      navigate('/customer/portal');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Något gick fel');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] dark:bg-[#0a0a0a] flex items-center justify-center px-4" data-testid="customer-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold tracking-tight text-foreground" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
            <span className="text-[#E8613A]">Operio</span> Kundportal
          </h1>
          <p className="text-sm text-muted-foreground mt-1">Följ dina projekt i realtid</p>
        </div>

        <div className="bg-white dark:bg-card border border-border rounded-xl p-6 shadow-sm">
          {/* Toggle */}
          <div className="flex rounded-lg bg-muted p-1 mb-6">
            <button
              onClick={() => setMode('login')}
              className={`flex-1 py-2 text-sm font-medium rounded-md transition-colors ${mode === 'login' ? 'bg-white dark:bg-background shadow-sm text-foreground' : 'text-muted-foreground'}`}
              data-testid="customer-login-tab"
            >
              <LogIn size={14} className="inline mr-1.5" /> Logga in
            </button>
            <button
              onClick={() => setMode('register')}
              className={`flex-1 py-2 text-sm font-medium rounded-md transition-colors ${mode === 'register' ? 'bg-white dark:bg-background shadow-sm text-foreground' : 'text-muted-foreground'}`}
              data-testid="customer-register-tab"
            >
              <UserPlus size={14} className="inline mr-1.5" /> Registrera
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {mode === 'register' && (
              <div className="space-y-1.5">
                <Label>Namn</Label>
                <Input value={name} onChange={e => setName(e.target.value)} placeholder="Ditt namn" data-testid="customer-name-input" />
              </div>
            )}
            <div className="space-y-1.5">
              <Label>E-post</Label>
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="din@email.se" required data-testid="customer-email-input" />
            </div>
            <div className="space-y-1.5">
              <Label>Lösenord</Label>
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Lösenord" required data-testid="customer-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#E8613A] hover:bg-[#d4552f] text-white" data-testid="customer-submit-btn">
              {loading ? 'Vänta...' : mode === 'login' ? 'Logga in' : 'Skapa konto'}
            </Button>
          </form>
        </div>

        <p className="text-center mt-4 text-xs text-muted-foreground">
          <Link to="/login" className="hover:underline">Företagsinloggning</Link>
        </p>
      </div>
    </div>
  );
}
